import { I18nThemed } from 'interfaces/mixins';
import { DNode } from '@dojo/framework/core/interfaces';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';

import { Messages, Bundle } from '@dojo/framework/i18n/i18n';
import { LocalizedMessages } from '@dojo/framework/core/mixins/I18n';

import { userstore, lccstore, rcslocationChangeProcess } from 'lcc-state';
import css from '../css/backview.m.css';

export interface BackviewProperties {
	baseurl: string;
	overrideurl: string;
}

@theme(css)
export class Backview extends I18nThemed<BackviewProperties> {
	showButton: boolean;

	constructor() {
		super();
		this.showButton = true;
	}

	protected get_nls(): LocalizedMessages<Messages> {
		const { get, path } = lccstore;
		const dynls = get(path('dynls'));
		const bundle: Bundle<Messages> | undefined = dynls && dynls.get('settings');
		if (!bundle) {
			return { isPlaceholder: true, format: () => '', messages: {} as Messages };
		}
		return this.localizeBundle(bundle);
	}

	protected selected(location: string, overrideurl: string): void {
		const { baseurl } = this.properties;

		if (!location) {
			return;
		}

		let oneLevelUp = location.split('/').slice(0, -1).join('/');

		if (oneLevelUp === baseurl || oneLevelUp.length < baseurl.length) {
			oneLevelUp = baseurl;
		}

		if (overrideurl) {
			oneLevelUp = overrideurl;
		}

		rcslocationChangeProcess(userstore)({
			baseurl: `${baseurl}`,
			location: `${oneLevelUp}`
		});
	}

	protected render(): DNode {
		const { get, path } = userstore;
		const rcslocation = get(path('rcslocation'));
		const { baseurl, overrideurl } = this.properties;
		const location = rcslocation[baseurl];

		this.showButton = location !== baseurl;

		const {
			messages: { back_title = '[settings] back_title' }
		} = this.get_nls();

		return this.showButton
			? v(
					'div',
					{
						tabIndex: 0,
						title: back_title,
						role: 'button',
						'aria-label': back_title,
						classes: [this.theme(css.root)],
						onclick: (event) => {
							event.stopImmediatePropagation();
							this.selected(location, overrideurl);
						}
					},
					[v('i', { classes: ['fa', 'fa-lg', 'fa-angle-double-left'] })]
			  )
			: null;
	}
}
